import React from "react";
import PersonListRenderer from "./renderers/PersonListRenderer";

interface HistoricAdminsPopoverViewProps
{
    data: Person[];
}

export default class HistoricAdminsPopoverView extends React.Component<HistoricAdminsPopoverViewProps>
{
    render(): React.ReactNode
    {
        return <div className={"m-3"}>
            <h6>Historic Admins</h6>
            <PersonListRenderer value={this.props.data} />
        </div>;
    }
}